import React from 'react';
import { Button, Modal, Row, Col, Label, FormGroup, Input } from 'reactstrap';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';

import { autoPhoneFormatter } from 'utils/fomatter';
import Logger from 'utils/logger';
import { requestPut } from 'utils/fetchHelper';
import { isValidResponse } from 'utils/responseValidChecker';

// 인증 현황 상세 모달
@inject('status', 'searchFilter', 'miniAlertModal', 'loader')
@observer
class NoCellDetailStatusModal extends React.Component {
  toggleModal = () => {
    const { status } = this.props;
    status.clearDetailStatus();
    status.set('noCellDetailModalIsOpen', !status.noCellDetailModalIsOpen);
  };

  // 수정 버튼 클릭 이벤트 처리
  handleSubmitButtonClick = () => {
    this.fetchModfiyStatus();
  };

  // 복사 버튼 클릭 이벤트 처리
  handleCopyClick = () => {
    const { miniAlertModal } = this.props;
    const txid = document.getElementById('detailTxid');
    txid.select();
    document.execCommand('Copy');
    miniAlertModal.show('복사되었습니다.');
  };

  // 인증현황 수정 API 호출
  fetchModfiyStatus = async () => {
    const { miniAlertModal, loader, searchFilter, status, fetchRefresh } = this.props;
    loader.show(true);

    const url = process.env.REACT_APP_ENDPOINT + '/v1/admin/api/statistics/auth';
    const body = {
      historyAuth: {
        id: status.detailStatus.id,
        referral: status.detailStatus.referral
      }
    };
    const responseData = await requestPut(url, body);
    loader.show(false);

    await isValidResponse(responseData, miniAlertModal, this.props.history);

    if (responseData.code === '0000') {
      this.toggleModal();
      status.clearDetailStatus();

      await searchFilter.set('page', 1);
      fetchRefresh();
      miniAlertModal.show('수정되었습니다.');
    } else {
      miniAlertModal.show(responseData.message);
    }
  };

  render() {
    const { status } = this.props;
    return (
      <Modal className="modal-lg" backdrop={'static'} isOpen={status.noCellDetailModalIsOpen} toggle={this.toggleModal}>
        <div className="modal-header justify-content-center">
          <button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={this.toggleModal}>
            <i className="nc-icon nc-simple-remove" />
          </button>
          <h4 className="title title-up">현황 상세 보기</h4>
        </div>
        <div className="modal-body  __modalScrollbar">
          <Row>
            <Col md="12">
              <div className="row">
                <Label className="col-md-2 col-form-label font-weight-bold text-center">지점명</Label>
                <FormGroup className="col-md-10">
                  <Input
                    readOnly
                    className="__textAlignCenter"
                    type="text"
                    name="departmentName"
                    value={status.detailStatus.departmentName}
                  />
                </FormGroup>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <div className="row">
                <Label className="col-md-2 col-form-label font-weight-bold text-center">시간</Label>
                <FormGroup className="col-md-10">
                  <Input
                    readOnly
                    className="__textAlignCenter"
                    type="text"
                    name="date"
                    value={status.detailStatus.date}
                  />
                </FormGroup>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <div className="row">
                <Label className="col-md-2 col-form-label font-weight-bold text-center">전화번호</Label>
                <FormGroup className="col-md-10">
                  <Input
                    readOnly
                    className="__textAlignCenter"
                    type="text"
                    value={autoPhoneFormatter(status.detailStatus.phone)}
                  />
                </FormGroup>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <div className="row">
                <Label className="col-md-2 col-form-label font-weight-bold text-center">오류코드</Label>
                <FormGroup className="col-md-10">
                  <Input
                    readOnly
                    className="__textAlignCenter"
                    type="text"
                    name="resultCode"
                    value={status.detailStatus.resultCode}
                  />
                </FormGroup>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <div className="row">
                <Label className="col-md-2 col-form-label font-weight-bold text-center">메세지</Label>
                <FormGroup className="col-md-10">
                  <Input
                    readOnly
                    md="8"
                    className="__textAlignCenter"
                    type="text"
                    name="resultMessage"
                    value={status.detailStatus.resultMessage}
                  />
                </FormGroup>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <div className="row">
                <Label className="col-md-2 col-form-label font-weight-bold text-center">메모</Label>
                <FormGroup className="col-md-10">
                  <Input
                    md="8"
                    className="__textAlignCenter"
                    type="text"
                    onChange={e => {
                      status.setDetailStatus('detailStatus', 'referral', e.target.value, null);
                    }}
                    name="referral"
                    value={status.detailStatus.referral}
                  />
                </FormGroup>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <div className="row">
                <Label className="col-md-2 col-form-label font-weight-bold text-center">txid</Label>
                <FormGroup className="col-md-8">
                  <Input
                    readOnly
                    className="__textAlignCenter"
                    type="text"
                    id="detailTxid"
                    name="txid"
                    value={status.detailStatus.txid}
                  />
                </FormGroup>
                <div className="col-md-2">
                  <Button className="btn-round __marginTop" color="primary" onClick={this.handleCopyClick}>
                    복사
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div className="modal-footer">
          <div className="left-side">
            <Button
              className="btn-link"
              color="info"
              data-dismiss="modal"
              type="button"
              onClick={this.handleSubmitButtonClick}>
              수정
            </Button>
          </div>
          <div className="divider" />
          <div className="right-side">
            <Button className="btn-link" color="danger" type="button" onClick={this.toggleModal}>
              닫기
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

NoCellDetailStatusModal.defaultProps = {
  fetchRefresh: async () => {
    Logger.log('[DetailStatusModal] - refresh function is undefined');
  }
};

export default NoCellDetailStatusModal;
